module.exports = __webpack_public_path__ + "img/bats.d5905d57.png";